import type { PostType } from "../post-type-step/postTypes";

import { IMAGE_EXTENSIONS } from "./isImageDesign";
import { VIDEO_EXTENSIONS } from "./isVideoDesign";

export function acceptedDesignExtensions(postType: PostType): string[] {
  const extensions =
    postType.format === "reel"
      ? [...VIDEO_EXTENSIONS]
      : [...IMAGE_EXTENSIONS, ...VIDEO_EXTENSIONS];

  return extensions.map((extension) => `.${extension}`);
}
